<template>
  <div>
    <FormLayout
      :tabs="this.tabs"
      :leftAction="this.leftAction"
      :onChangeTab="onChangeTabIndex"
      :cardInfo="this.cardInfo"
    ></FormLayout>
  </div>
</template>

<script>
import Vue from "vue";
import FormLayout from "../../../layouts/FormLayout.vue";
import RoutesPaths from "../../../router/router-structure/routes-paths";

Vue.component("external-link-form-view", () =>
  import("./ExternalLinkForm.vue")
);

export default {
  components: {
    FormLayout,
  },
  async mounted() {
    if (this.$route.params.id) {
      this.leftAction.text = "Editar comunicado 11111";
    }
  },
  data: function() {
    return {
      currentTabIndex: 0,
      cardInfo: {
        headerIcon: "far fa-file",
        icon: "MDI-link-box-outline.svg",
        title: "Gerenciamento de Links externos",
        description: "Atualize e gerencie os links externos disponíveis no portal",
      },
      leftAction: {
        text: "Links externos",
        onClick: this.leftActionClickHandler,
      },
      leftLinkNavigation: this.leftHistoryNavigation,

      tabs: [
        {
          title: "Informações Gerais",
          formComponent: "external-link-form-view",
        },
      ],
    };
  },
  methods: {
    onChangeTabIndex(newValue) {
      this.currentTabIndex = newValue;
    },
    leftActionClickHandler() {
      this.$router.push(RoutesPaths.contentManagement.rootName());
    },
    leftHistoryNavigation() {
      this.$router.push({
        path: RoutesPaths.requestHistory.rootName(),
        params: {
          serviceType: this.tabs[this.currentTabIndex].serviceType,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
